var classes = {"modalBlockRoot":"W8ETC","modalBlockFull":"Fr-9P","modalBlockContent":"Cas-o","modalBlockContentFull":"zp9K7"};

export { classes as default };
